/**
 * @generated SignedSource<<fa819462fa30ff28e05455ab767043a0>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type DesignerDirectoryHeader_viewer$data = {
  readonly " $fragmentSpreads": FragmentRefs<"DesignerDirectoryLocationFilter_viewer" | "DesignerDirectorySearch_viewer">;
  readonly " $fragmentType": "DesignerDirectoryHeader_viewer";
};
export type DesignerDirectoryHeader_viewer$key = {
  readonly " $data"?: DesignerDirectoryHeader_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"DesignerDirectoryHeader_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "DesignerDirectoryHeader_viewer",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "DesignerDirectorySearch_viewer"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "DesignerDirectoryLocationFilter_viewer"
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "b2d6777ca735d74bfbde3c7326654bd4";

export default node;
